import { ReactNode } from 'react';

import { Tooltip } from '@/design-system';
import { cn } from '@/utils/tailwind';

export function PlaygroundButton({
  text,
  onClick,
  tooltipTitle,
  disabled,
  startDecorator,
  endDecorator,
  minimized,
  className,
}: {
  text: string | ReactNode;
  onClick?: () => void;
  tooltipTitle?: string;
  disabled?: boolean;
  startDecorator?: ReactNode;
  endDecorator?: ReactNode;
  minimized?: boolean;
  className?: string;
}) {
  return (
    <Tooltip title={tooltipTitle}>
      <button
        type="button"
        data-testid={
          typeof text === 'string'
            ? `playground-add-${text.split(' ').join('-').toLowerCase()}`
            : 'playground-add'
        }
        onClick={onClick}
        className={cn(
          'whitespace-nowrap rounded-md border border-primary bg-background text-sm font-medium hover:bg-secondary',
          disabled &&
            'cursor-not-allowed opacity-50 hover:bg-background hover:opacity-50',
          minimized ? 'p-[5px]' : 'px-2.5 py-[3px]',
          className
        )}
        disabled={disabled}
      >
        <div className="flex flex-row gap-1">
          {startDecorator}
          {!minimized && <div className="my-auto">{text}</div>}
          {endDecorator}
        </div>
      </button>
    </Tooltip>
  );
}

export const PlaygroundIcon = ({
  children,
  tooltipTitle,
  className,
  disabled,
}: {
  children: ReactNode;
  tooltipTitle?: string;
  className?: string;
  disabled?: boolean;
}) => (
  <Tooltip title={tooltipTitle}>
    <div
      className={cn(
        'flex cursor-pointer items-center justify-center rounded-md border border-primary bg-background px-0.5 text-xs font-medium hover:bg-secondary',
        disabled &&
          'cursor-default opacity-50 hover:bg-background hover:opacity-50',
        className
      )}
    >
      {children}
    </div>
  </Tooltip>
);
